import { Component } from '@angular/core';

@Component({
  selector: 'app-accent-row',
  templateUrl: './accent-row.component.html',
  styleUrls: ['./accent-row.component.scss'],
})
export class AccentRowComponent {}
